 <div class="flex flex-col flex-auto min-w-0">
    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">
        <!-- CONTENT GOES HERE -->
        <div><div class="content">
    <br>
    <div>
        <span class="h3">ChemIQ Status</span>
    </div>
    <br>
    <br>
    <table class="table table-striped tablefixed">
        <thead>
            <tr>
                <th>Supplier Name</th>
                <th>CIL Upload</th>
                <th>Upload Date</th>

                <th>ChemIQ Started</th>
                <th>MTS Status</th>
                <th>Report Generated</th>

            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let chemIq of chemIqStatusList">
                <td>{{chemIq.organizationName}}</td>
               
                <td><span>Yes</span> </td>
                <td>{{chemIq.uploadedOn|date:'mediumDate'}}</td>
                <td>
                    <span *ngIf="chemIq.chemiqStarted==1">Yes</span>
                    <span *ngIf="chemIq.chemiqStarted==0"> No</span>
                </td>


                <td> <span *ngIf="chemIq.mtsStatus==1">Finalized</span>
                    <span *ngIf="chemIq.mtsStatus==0">Incomplete</span>
                </td>
                <td><span *ngIf="chemIq.reportGenerated==1">Yes</span>
                    <span *ngIf="chemIq.reportGenerated==0">No</span>
                </td>


            </tr>
        </tbody>
    </table>
</div>

		</div>
		</div>
		</div>
		